export const ACHIEVEMENT_RECORDS = '/achievement-records'
export const ACHIEVEMENT_RECORDS_INFO = `${ACHIEVEMENT_RECORDS}/info`
export const STUDENT_ACHIEVEMENT_RECORDS = '/student-achievement-records'
